import { createFileRoute } from '@tanstack/react-router';
import { CHECKLIST_CODE } from '@cis/api-client';
import { checklistQuery } from '../../api/checklists.ts';
import { ChecklistPage } from '../../features/checklists/checklist-page.tsx';
import { NotFoundChecklist } from '../../features/checklists/not-found.tsx';
import { validateRunListSearch } from '../../features/checklists/search.ts';

// One checklist and its runs (T28). ?page and ?status keep the run list in the URL.
export const Route = createFileRoute('/_authed/checklists/$code/')({
  validateSearch: validateRunListSearch,
  loader: ({ context, params }) => {
    if (CHECKLIST_CODE.test(params.code)) {
      void context.queryClient.prefetchQuery(checklistQuery(params.code));
    }
  },
  component: ChecklistRoute,
});

function ChecklistRoute(): React.JSX.Element {
  const { code } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  if (!CHECKLIST_CODE.test(code)) return <NotFoundChecklist />;
  return (
    <ChecklistPage
      key={code}
      code={code}
      search={search}
      onSearch={(next) => void navigate({ search: validateRunListSearch({ ...next }) })}
    />
  );
}
